// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container {
  max-width: 400px;
  width: 100%;
  background: white;
  box-shadow: 0 10px 15px rgba(0,0,0,0.1);
  border-radius: 0.5rem;
  display: flex;
  pointer-events: auto;
  border: 1px solid rgba(0, 0, 0, 0.05);
  font-family: Arial, sans-serif;
  overflow: hidden;
  animation-duration: 300ms;
  animation-fill-mode: forwards;
}

.animate-enter {
  animation-name: toastEnter;
}

.animate-leave {
  animation-name: toastLeave;
}

@keyframes toastEnter {
  from {opacity: 0; transform: translateX(100%);}
  to {opacity: 1; transform: translateX(0);}
}

@keyframes toastLeave {
  from {opacity: 1; transform: translateX(0);}
  to {opacity: 0; transform: translateX(100%);}
}

.toast-content {
  flex: 1 1;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
}

.toast-message {
  display: flex;
  align-items: start;
}

.toast-image img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  margin-right: 0.75rem;
  object-fit: cover;
}

.toast-text {
  flex: 1 1 auto;
}

.toast-title {
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  color: #1f2937; /* gray-900 */
  margin: 0;
}

.toast-body {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #6b7280; /* gray-500 */
}

.toast-close {
  border-left: 1px solid #e5e7eb; /* gray-200 */
  display: flex;
  align-items: center;
}

.toast-close button {
  border: none;
  background: transparent;
  padding: 1rem;
  width: 80px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #4f46e5; /* indigo-600 */
  cursor: pointer;
  transition: color 0.2s ease;
}

.toast-close button:hover {
  color: #6366f1; /* indigo-500 */
}

.toast-close button:focus {
  outline: none;
  box-shadow: 0 0 0 2px #6366f1;
}
`, "",{"version":3,"sources":["webpack://./src/Notification.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,uCAAuC;EACvC,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,MAAM,UAAU,EAAE,2BAA2B,CAAC;EAC9C,IAAI,UAAU,EAAE,wBAAwB,CAAC;AAC3C;;AAEA;EACE,MAAM,UAAU,EAAE,wBAAwB,CAAC;EAC3C,IAAI,UAAU,EAAE,2BAA2B,CAAC;AAC9C;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,cAAc,EAAE,aAAa;EAC7B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,8BAA8B,EAAE,aAAa;EAC7C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,eAAe;EAC/B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B","sourcesContent":[".toast-container {\n  max-width: 400px;\n  width: 100%;\n  background: white;\n  box-shadow: 0 10px 15px rgba(0,0,0,0.1);\n  border-radius: 0.5rem;\n  display: flex;\n  pointer-events: auto;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  font-family: Arial, sans-serif;\n  overflow: hidden;\n  animation-duration: 300ms;\n  animation-fill-mode: forwards;\n}\n\n.animate-enter {\n  animation-name: toastEnter;\n}\n\n.animate-leave {\n  animation-name: toastLeave;\n}\n\n@keyframes toastEnter {\n  from {opacity: 0; transform: translateX(100%);}\n  to {opacity: 1; transform: translateX(0);}\n}\n\n@keyframes toastLeave {\n  from {opacity: 1; transform: translateX(0);}\n  to {opacity: 0; transform: translateX(100%);}\n}\n\n.toast-content {\n  flex: 1 1 0%;\n  padding: 1rem;\n  display: flex;\n  align-items: flex-start;\n}\n\n.toast-message {\n  display: flex;\n  align-items: start;\n}\n\n.toast-image img {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  margin-right: 0.75rem;\n  object-fit: cover;\n}\n\n.toast-text {\n  flex: 1 1 auto;\n}\n\n.toast-title {\n  font-size: 0.875rem; /* 14px */\n  font-weight: 600;\n  color: #1f2937; /* gray-900 */\n  margin: 0;\n}\n\n.toast-body {\n  margin-top: 0.25rem;\n  font-size: 0.875rem;\n  color: #6b7280; /* gray-500 */\n}\n\n.toast-close {\n  border-left: 1px solid #e5e7eb; /* gray-200 */\n  display: flex;\n  align-items: center;\n}\n\n.toast-close button {\n  border: none;\n  background: transparent;\n  padding: 1rem;\n  width: 80px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #4f46e5; /* indigo-600 */\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.toast-close button:hover {\n  color: #6366f1; /* indigo-500 */\n}\n\n.toast-close button:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px #6366f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
